import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { Rater } from '../interfaces/Rater';
import { UpdateRaterMode } from '../constants/updateRaterMode';

/** Helper method to get rater's info dept and country */
export const getRaterInfo = (rater: Rater): string => {
  let raterInfo = '';
  if (rater.dept && rater.country) {
    raterInfo = `${rater.dept} | ${rater.country}`;
  } else if (rater.dept && !rater.country) {
    raterInfo = rater.dept;
  } else {
    raterInfo = rater.country;
  }
  return raterInfo;
};

/** Helper method to call api to update rater */
export const updateRater = async (
  action: UpdateRaterMode.ADD | UpdateRaterMode.UPDATE | UpdateRaterMode.DELETE | UpdateRaterMode.SEARCH_ADD,
  rater?: Rater,
  roleId?: string,
  ratingId?: number,
  raterIdToRemove?: number,
): Promise<string> => {
  try {
    const request = {
      action,
      roleId,
      raterId: raterIdToRemove && action === UpdateRaterMode.DELETE ? raterIdToRemove : rater ? rater.raterId : null,
      ratingId: raterIdToRemove && action === UpdateRaterMode.DELETE ? ratingId : null,
      firstName: rater ? rater.firstName : null,
      lastName: rater ? rater.lastName : null,
      email: rater ? rater.email : null,
      language: rater ? rater.language : null,
    };

    const { status } = await axios.post(apiUrls.POST_MFS_ADD_UPDATE_RATER, request);

    if (status === 200) {
      return '';
    } else if (status === 208) {
      return action === UpdateRaterMode.SEARCH_ADD ? 'searchAddRaterExistValidation' : 'addNewRaterExisitValidation';
    } else {
      return 'administratorGenericError';
    }
  } catch (e) {
    return 'administratorGenericError';
  }
};
